import commonStyles from '../auth/common.module.scss';

export default function CommonBorder() {
  return <div className={commonStyles['content-border']}></div>;
}
